module.exports = __webpack_public_path__ + "static/img/_MG_4039-1080p.7da863f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio4/_MG_4039-1080p.jpg
// module id = plUq
// module chunks = 0